// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invItemId } from './InvItem';
import { invSterilizationMethodEnum } from './InvSterilizationMethodEnum';
import { invSterilizationPresetId } from './InvSterilizationPreset';
import { operatorId } from './Operator';
import { z } from 'zod';
export const invSterilizationId = (z.number());
export const invSterilization = z.object({
    id: invSterilizationId,
    item_id: invItemId,
    method: invSterilizationMethodEnum,
    temperature_c: z.string().nullable(),
    hold_min: z.number().nullable(),
    preset_id: invSterilizationPresetId.nullable(),
    performed_at: z.date(),
    operator_id: operatorId.nullable(),
    note: z.string().nullable(),
    created_at: z.date(),
});
export const invSterilizationInitializer = z.object({
    id: invSterilizationId.optional(),
    item_id: invItemId,
    method: invSterilizationMethodEnum,
    temperature_c: z.string().optional().nullable(),
    hold_min: z.number().optional().nullable(),
    preset_id: invSterilizationPresetId.optional().nullable(),
    performed_at: z.date(),
    operator_id: operatorId.optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
export const invSterilizationMutator = z.object({
    id: invSterilizationId.optional(),
    item_id: invItemId.optional(),
    method: invSterilizationMethodEnum.optional(),
    temperature_c: z.string().optional().nullable(),
    hold_min: z.number().optional().nullable(),
    preset_id: invSterilizationPresetId.optional().nullable(),
    performed_at: z.date().optional(),
    operator_id: operatorId.optional().nullable(),
    note: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=InvSterilization.js.map